import ReactGA from "react-ga4";
import { getGAMeasurementId } from "./api/ConfigClient";

let gaIdFetched = false;

export const initGA = async () => {
    if (gaIdFetched) return;

    try {
        const measurementId = await getGAMeasurementId();
        gaIdFetched = true;

        if (measurementId) {
            console.log("Initializing Google Analytics with measurement ID:", measurementId);
            ReactGA.initialize(measurementId, {
                gaOptions: {
                    siteSpeedSampleRate: 100,
                },
                gtagOptions: {
                    send_page_view: false,
                },
            });
        }
    } catch (error) {
        console.error("Failed to initialize Google Analytics:", error);
    }
};

const getSessionAttrs = (localStorageKey: string): {} => {
    try {
        const json = localStorage.getItem(localStorageKey);
        if (json) {
            return JSON.parse(json);
        }
    } catch (error) {
        // ignore localStorage and JSON parse errors
    }
    return {};
};

export const trackPageView = (path: string, eventAttrs: { [key: string]: any }) => {
    const sessionAttrs = getSessionAttrs("ga");
    ReactGA.send({ ...sessionAttrs, ...eventAttrs, hitType: "pageview", page: path });
};
